import axios from "axios";

export const PERSONNEL_TYPE_URL = "/PersonnelType";
export const PERSONNEL_REPORT_URL = "/PersonnelReport";

/** Belli Bir Personel Raporunu Elde Eder */
export function getPersonnelReport(queryParams) {
  return axios.post(`${PERSONNEL_REPORT_URL}/GetPersonnelReport`, queryParams);
}

/** Belli Bir Personel Raporunu Sayfalama Olmadan Elde Eder */
export function getAllPersonnelReport(queryParams) {
  return axios.post(`${PERSONNEL_REPORT_URL}/GetAllPersonnelReport`, queryParams);
}

/** Mevcut Okulun Personel Türü Listesini Öğretmen İle Beraber Elde Eder */
export function getPersonnelTypes() {
  return axios.get(`${PERSONNEL_TYPE_URL}/GetPersonnelTypesWithTeacher`);
}